import toPixels from '@lib/to-pixels'
import clsx from 'clsx'
import { FC } from 'react'
import styles from './WishListIcon.module.scss'

type WishListIconProps = {
  color?: 'black' | 'white'
  filled?: boolean
  width?: number
  height?: number
  className?: string
}

const WishListIcon: FC<WishListIconProps> = ({
  color,
  filled,
  width,
  height,
  className,
}) => {
  return (
    <svg
      className={clsx(styles.svg, className)}
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      width={toPixels(width)}
      height={toPixels(height)}
    >
      <path
        className={clsx({
          [styles.black]: color == 'black',
          [styles.white]: color == 'white',
          [styles.filled]: filled,
        })}
        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
      ></path>
    </svg>
  )
}

export default WishListIcon
